<template>
  <div>
    <LoadingAnimation full-page v-if="loadingAnimationFullPage"/>
    <template v-if="pdfPage">
      <StatisticProjectReportsBlankPDF
        :project="data.data.project"
        :date="dateInfo"
        :employees="data.data.employees"
        :confirmed="reports.confirmed"
        :current-bill-id="currentBillId"
        :notes="notes"
        :images="images"
        :images-count="images_count"
        :key="images_count.key + '_' + $route.fullPath"
      />
    </template>
    <template v-else>
      <StatisticProjectReportsBlankConfirmTable
        v-if="confirmPage"
        :project="data.data.project"
        :date="dateInfo"
        :employees="data.data.employees"
        :current-bill-id="currentBillId"
        :on-confirm-page="onConfirmPage"
        :confirm-page="confirmPage"
        :confirmed="reports.confirmed"
        :on-change-confirm="onChangeReportsConfirm"
        :on-change-notes="onChangeNotes"
        :notes="notes"
        :on-change-images="onChangeImages"
        :images="images"
        :on-change-images-count="onChangeImagesCount"
        :key="'confirmTable' + key + confirmPage"
      />
      <StatisticProjectReportsBlankExcelTable
        v-else
        :project="data.data.project"
        :date="dateInfo"
        :total-work-types="data.data.work_types"
        :total-extras="data.data.extras"
        :employees="data.data.employees"
        :current-bill-id="currentBillId"
        :on-update="onUpdate"
        :on-confirm-page="onConfirmPage"
        :key="'excelTable' + key + $route.fullPath"
      />
    </template>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'
import StatisticProjectReportsBlankExcelTable from "./blank/excel/StatisticProjectReportsBlankExcelTable";
import LoadingAnimation from "../../LoadingAnimation";
import StatisticProjectReportsBlankConfirmTable from "./blank/confirm/StatisticProjectReportsBlankConfirmTable";
import StatisticProjectReportsBlankPDF from "components/timeControl/reports/blank/pdf/StatisticProjectReportsBlankPDF";

export default {
  name: 'StatisticProjectReportsBlank',
  components: {
    StatisticProjectReportsBlankPDF,
    StatisticProjectReportsBlankConfirmTable,
    LoadingAnimation,
    StatisticProjectReportsBlankExcelTable
  },
  props: {
    data: Object,
    weeks: String,
    onReportShow: {},
    onReportUpdate: {}
  },
  data: () => ({
    key: 0,
    loadingAnimationFullPage: false,
    currentBillId: null,
    confirmPage: false,
    reports: {
      confirmed: {
        work_types: [],
        extras: []
      },
      additional: []
    },
    notes: true,
    images: false,
    images_count: {
      key: 0,
      value: {
        0: 1,
      }
    },
    // units: ['t', 'm²', 'm³', 'kpl', 'jm', 'erä'],

  }),
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('user', ['userData']),
    ...mapGetters('workClientProjectsClientReports', ['workClientProjectsClientReportsGeneralNote']),

    pdfPage() {
      return (
        this.$route.name === 'timeControlShowReportsViewPdf'
        || this.$route.name === 'timeControlShowReportsViewFreePdf'
        || this.$route.name === 'linkProjectReportSign'
      )
    },
    dateInfo() {
      return this.$formatDate(this.data.start_date)
        + (this.data.end_date
          ? (' - ' + this.$formatDate(this.data.end_date))
          : '')
        + (this.weeks
          ? (' ' + this.localStorage.translations.pages.finance['period-table'].weeks + ' ' + this.weeks)
          : '')
    },
  },
  watch: {
    '$route.params.report_id': {
      handler() {
        this.initializeReportState()
      },
    },
  },
  mounted() {
    this.initializeReportState()
  },
  methods: {
    ...mapActions('workClientProjectsClientReports', [
      'onWorkClientProjectsClientReportsBillGrid',
      'onWorkClientProjectsClientReportsBillUpdate',
    ]),
    async initializeReportState() {
      await this.loadCurrentBillId()
      this.prepareReportsData()
    },
    async loadCurrentBillId() {
      let reportId = this.$route.params.report_id
      this.currentBillId = null
      if (!reportId) return
      await this.onWorkClientProjectsClientReportsBillGrid({report: reportId})
        .then((res) => {
          let bills = res?.data?.data || []
          if (bills.length === 0) return
          let sorted = Object.assign([], bills).sort((a, b) => Number(b.id) - Number(a.id))
          this.currentBillId = sorted[0]?.id || null
        })
        .catch(() => {})
    },
    async onUpdate(data, switchValue, paid, extra) {
      if (!paid) this.onChangeReportsConfirm(extra ? 'extras' : 'work_types', data.map(i => i.id), switchValue)
      if (data && data.length > 0) {
        this.loadingAnimationFullPage = true
        try {
          if (!paid) {
            if (switchValue) {
              await this.syncCurrentBillAfterCheck()
            } else {
              await this.syncCurrentBillAfterUncheck(data.map((i) => i.id))
            }
          }
          if (this.onReportUpdate) {
            await this.onReportUpdate({
              id: this.$route.params.report_id,
              data: data,
              paid: paid,
              extra: extra
            })
            await this.updateReport()
          } else {
            this.loadingAnimationFullPage = false
          }
        } catch (err) {
          this.loadingAnimationFullPage = false
          this.$store.dispatch(
            'popup/onMessage',
            {
              message: this.localStorage.translations.pages.common.notifications['oshibka'],
              IsError: true,
            },
            {root: true},
          )
        }
      }
    },
    buildCurrentBillUpdatePayload(excludedIds = []) {
      const isEmptyBillId = (value) => {
        return value === null || value === undefined || value === '' || value === 'null'
      }
      const isSameBillId = (value, currentBillId) => {
        if (isEmptyBillId(value) || isEmptyBillId(currentBillId)) return false
        return String(value) === String(currentBillId)
      }
      const excluded = new Set(Object.assign([], excludedIds).map((id) => String(id)))
      const reportId = this.$route.params.report_id
      const reportStatusMap = {
        work_types: {},
        extras: {},
      }
      let employees = Object.values(this?.data?.data?.employees || [])
      for (let e in employees) {
        let employee = employees[e]
        for (let type of ['work_types', 'extras']) {
          let works = employee?.[type] || {}
          for (let w in works) {
            let days = works[w]?.days || {}
            for (let d in days) {
              let reports = days[d]?.reports || []
              for (let r in reports) {
                let report = reports[r]
                if (!report || !report.id) continue
                reportStatusMap[type][String(report.id)] = {
                  status: report.client_report_status || null,
                  client_bill_id: isEmptyBillId(report.client_bill_id) ? null : report.client_bill_id,
                }
              }
            }
          }
        }
      }
      const filterIdsForBill = (ids, type) => {
        let map = reportStatusMap[type] || {}
        return Object.assign([], ids).filter((id) => {
          if (excluded.has(String(id))) return false
          let item = map[String(id)] || {}
          let status = item.status
          let clientBillId = item.client_bill_id
          return (status !== 'signed' && status !== 'approved')
            && (isEmptyBillId(clientBillId) || isSameBillId(clientBillId, this.currentBillId))
        })
      }
      return {
        period_report_id: reportId,
        employee_reports: filterIdsForBill(this.reports.confirmed.work_types, 'work_types'),
        work_extras: filterIdsForBill(this.reports.confirmed.extras, 'extras'),
        report_with_employee_notes: this.notes ? 1 : 0,
        general_note: this?.workClientProjectsClientReportsGeneralNote?.[reportId]?.reportGeneralNote || '',
      }
    },
    async syncCurrentBillAfterUncheck(excludedIds = []) {
      if (!this.currentBillId) {
        await this.loadCurrentBillId()
      }
      if (!this.currentBillId) return
      await this.onWorkClientProjectsClientReportsBillUpdate({
        id: this.currentBillId,
        data: this.buildCurrentBillUpdatePayload(excludedIds),
      })
    },
    async syncCurrentBillAfterCheck() {
      if (!this.currentBillId) {
        await this.loadCurrentBillId()
      }
      if (!this.currentBillId) return
      await this.onWorkClientProjectsClientReportsBillUpdate({
        id: this.currentBillId,
        data: this.buildCurrentBillUpdatePayload(),
      })
    },

    async updateReport() {
      if (this.onReportShow)
        await this.onReportShow(this.$route.params.report_id).then(() => {
          this.loadingAnimationFullPage = false
          this.initializeReportState()
          this.key++
        })
    },

    onConfirmPage(value) {
      this.confirmPage = value
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },

    prepareReportsData() {
      this.images = this?.data?.data?.project?.images_in_report || false
      const isEmptyBillId = (value) => {
        return value === null || value === undefined || value === '' || value === 'null'
      }
      const isSelectable = (report) => {
        const isSameBillId = (value, currentBillId) => {
          if (isEmptyBillId(value) || isEmptyBillId(currentBillId)) return false
          return String(value) === String(currentBillId)
        }
        if (!report) return false
        if (report.approved_report <= 0) return false
        if (report.client_report_status === 'signed' || report.client_report_status === 'approved') return false
        if (!isEmptyBillId(report.client_bill_id) && !isSameBillId(report.client_bill_id, this.currentBillId)) return false
        return true
      }
      const isInBill = (report) => {
        const isSameBillId = (value, currentBillId) => {
          if (isEmptyBillId(value) || isEmptyBillId(currentBillId)) return false
          return String(value) === String(currentBillId)
        }
        if (!report) return false
        if (report.approved_report <= 0) return false
        if (!this.currentBillId) return false
        return isSameBillId(report.client_bill_id, this.currentBillId)
      }
      let employees = Object.values(this.data.data.employees)
      for (let type in this.reports.confirmed) {
        this.reports.confirmed[type] = []
        for (let id in employees) {
          let days = Object.values(employees[id][type])
            .map(data => Object.values(data.days).map(day => day.reports))
          for (let day in days)
            for (let work in days[day])
              for (let r in days[day][work])
                if (isSelectable(days[day][work][r]) || isInBill(days[day][work][r]))
                  this.reports.confirmed[type].push(days[day][work][r].id)
          for (let item in this.data.data.employees[id][type]) {
            let ddd = Object.keys(this.data.data.employees[id][type][item].days)
            for (let dd in ddd) {
              let d = ddd[dd]
              for (let r in this.data.data.employees[id][type][item].days[d].reports) {
                if (this.data.data.employees[id][type][item].days[d].reports[r].image) {
                  this.data.data.employees[id][type][item].days[d].reports[r].image = JSON.parse(this.data.data.employees[id][type][item].days[d].reports[r].image)
                }
              }
            }
          }
        }
      }
    },

    onChangeReportsConfirm(type, collection, switchValue, type2, collection2) {
      for (let i in collection) {
        let index = this.reports.confirmed[type].indexOf(collection[i])
        if (switchValue) {
          if (index === -1) this.reports.confirmed[type].push(collection[i])
        } else if (index > -1) this.reports.confirmed[type].splice(index, 1)
      }
      for (let i in collection2) {
        let index = this.reports.confirmed[type2].indexOf(collection2[i])
        if (switchValue) {
          if (index === -1) this.reports.confirmed[type2].push(collection2[i])
        } else if (index > -1) this.reports.confirmed[type2].splice(index, 1)
      }
      this.key++
    },

    onChangeNotes() {
      this.notes = !this.notes
    },

    onChangeImages() {
      this.images = !this.images
    },

    onChangeImagesCount(data) {
      for (let i in data) {
        this.images_count.value[i] = data[i]
      }
      this.images_count.key++
    }

  }
}
</script>

<style scoped lang="scss">
:deep() .fixedBtn {
  z-index: 10;
  position: fixed;
  bottom: 165px;
  right: 10px;
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 1fr;
  grid-gap: 4px;

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    padding: 15px 12px;
    bottom: 135px;
    right: -2px;
  }

  .v-btn {
    background-color: #277FAF !important;
    color: #F2F2F2 !important;
    border-radius: 50px !important;

    &:hover {
      background-color: white !important;
      color: #277FAF !important;
      border: 1px solid #277FAF !important;
    }
  }
}
</style>
